// react-app/src/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Login.css';

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    try {
      const response = await fetch('https://epicnyte.sablis.com/api/token-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ username, password }),
        credentials: 'omit',
      });

      if (!response.ok) {
        const errData = await response.json();
        setError(errData.message || 'Login failed');
        return;
      }

      const data = await response.json(); // { token: "...", user: { ... } }

      login(data.token, data.user); // save token & user in context
      setError('');
      navigate('/dashboard'); // redirect after login
    } catch (err) {
      console.error(err);
      setError('Network error, please try again.');
    }
  };

  return (
      <div className="login-container">
        <h2>EpicNyte Admin Login</h2>
        <input
          type="text"
          id="username"
          name="username"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="button" onClick={handleLogin}>
          Login
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>

  );
}

export default Login;
